import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ChakraProvider, useColorMode } from '@chakra-ui/react'; // ✅ Ajout de useColorMode
import { ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import { ReactLenis } from '@studio-freight/react-lenis';

// Import des widgets et protections
import ProtectedRoute from './component/ProtectedRoute';
import QuickCallWidget from './component/Widgets/QuickCallWidget';
import CookieBanner, { useCookieConsent } from './component/CookieBanner/CookieBanner';
import NotFound from './component/NotFound/NotFound';

// Import de vos composants
import Header from './component/header/header';
import Footer from './component/footer/footer';
import Home from './component/Home/home.js';
import Agence from './component/Agence/agence.js';
import Certif from './component/Certif/certif.js';
import Enfant from './component/Prestation/Enfant/enfant.js';
import Senior from './component/Prestation/Senior/senior.js';
import Contact from './component/contact/contact.js';
import Login from './component/connexion/connexion.js';
import DemandeAcces from './component/connexion/DemandeAcces.js';
import Blog from './component/Blog/blog.js';
import AjouterArticle from './component/AjouterArticle.js/AjouterArticle.js';
import ModifierArticle from './component/Blog/ModifierArticle.js';
import BlogDetail from './component/blogDetails/blogDetail.js';
import Devis from './component/Devis/devis.js';
import AccompagnementHandicap from './component/Prestation/Accompagnement/accompagnement_handicap.js';
import TransportPMR from './component/Prestation/TransportPmr/transport.js';
import Entretiens from './component/Prestation/Entretiens/entretien_domicile.js';
import AideFinanciere from './component/Tarif/Aide_financiere/aide_financiere.js';
import BaseTarifaire from './component/Tarif/Base_Tarifaire/base_tarifaire.js';
import NosRessources from './component/Ressource/ressource.js';
import RessourcesForm from './component/Ressource/ressourceForm.js';
import Presentation from './component/Presentation/presentation.js';
import NosPartenaires from './component/Partenaires/partenaires.js';
import Recrutement from './component/recrutement/recrutement.js';
import MentionLegal from './component/Mention/mention_legal.js'
import PolitiqueConfidentialite from './component/PolitiqueConfidentialite/politique_confidentialite.js'
import Dashboard from './component/Dashboard/Dashboard.js'
import Journal from './component/Journal/journal.js'
import JournalDetail from './component/Journal/journalDetail.js'
import AjouterJournal from './component/Journal/AjouterJournal.js'
import ModifierJournal from './component/Journal/ModifierJournal.js'
import theme from './theme';
import ScrollToTop from "./component/ScrollToTop";
import SimulateurAides from './component/AideFinanciereSimulateur/SimulateurAides';

import ReactGA from "react-ga4";

function AppContent() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const { consent, accept, refuse } = useCookieConsent();

  const handleAccept = () => {
    accept();
    const gaId = process.env.REACT_APP_GA4_ID;
    if (gaId) {
      ReactGA.initialize(gaId);
      ReactGA.send("pageview");
    }
  };

  return (
    <Router>
      <ToastContainer 
        position="top-center" 
        autoClose={5000} 
        theme="colored"
      />
      
      <ScrollToTop />
      <Header />
      
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/demande-de-devis' element={<Devis />} />
        <Route path="/agences" element={<Agence />} />
        <Route path="/enfants" element={<Enfant />} />
        <Route path="/agrements" element={<Certif />} />
        <Route path="/seniors" element={<Senior />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/connexion" element={<Login />} />
        <Route path="/demande-acces" element={<DemandeAcces />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/recrutement" element={<Recrutement />} />
        <Route path="/personnes-handicapees" element={<AccompagnementHandicap />} />
        <Route path="/transport-de-pmr" element={<TransportPMR />} />
        <Route path="/entretien-du-domicile" element={<Entretiens />} />
        <Route path="/aide-financiere" element={<AideFinanciere />} />
        <Route path="/tarifs" element={<BaseTarifaire />} />
        <Route path="/NosRessources" element={<NosRessources />} />
        <Route path="/Presentation" element={<Presentation />} />
        <Route path="/NosPartenaires" element={<NosPartenaires />} />
        <Route path="/mentions-legales" element={<MentionLegal />} />
        <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/simulateur-aides" element={<SimulateurAides />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:id" element={<JournalDetail />} />

        <Route path="/ajouter-article" element={
          <ProtectedRoute><AjouterArticle /></ProtectedRoute>
        } />
        
        <Route path="/modifier-article/:id" element={
          <ProtectedRoute><ModifierArticle /></ProtectedRoute>
        } />

        <Route path="/RessourcesForm" element={
          <ProtectedRoute><RessourcesForm /></ProtectedRoute>
        } />

        <Route path="/admin" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />

        <Route path="/ajouter-journal" element={
          <ProtectedRoute><AjouterJournal /></ProtectedRoute>
        } />
        <Route path="/modifier-journal/:id" element={
          <ProtectedRoute><ModifierJournal /></ProtectedRoute>
        } />

        <Route path="*" element={<NotFound />} />
      </Routes>
      
      <Footer />

      {/* ✅ Le téléphone qui pulse apparaîtra sur TOUTES les pages ici */}
      <QuickCallWidget isDark={isDark} />
      <CookieBanner onAccept={handleAccept} onRefuse={refuse} />
    </Router>
  );
}

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ReactLenis root options={{ 
        lerp: 0.1,
        duration: 1.2,
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
      }}>
        <AppContent />
      </ReactLenis>
    </ChakraProvider>
  );
}

export default App;